import React from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import Button from '../../../atoms/button';
import ModuleCategory from '../../../components/module_category';
import LoadingSpinner from '../../../atoms/loading';
import I10n from '../../../features/i10n';
import MsxIcons from "../../msx-icons";
import PacdriveOptions from '../../../components/pacdrive_options';
import Scrollbars from 'react-custom-scrollbars';
import { PRIMARY_COLOR } from "../../../color-constants";


const Container = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
  border-radius: 10px;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 16px 20px;
  align-items: stretch;
  border-top: 2px solid #cccc;
  background-color: #f4f4f4;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const DescriptionText = styled.div`
  font-size: 14px;
  white-space: pre-line;
  padding-bottom: 10px;
`;

const ContentWrapper = styled.div`
  flex: 1 1 auto;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const DeviceSectionHeadText = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  line-height: 36px;
  margin-left: 25px;
  @media (max-width: 800px) {
    margin-left: 0;
  }
`;

const DeviceSectionContent = styled.div`
  position: relative;
  flex: 1 1 0px;
  background-color: #F4F4F4;
  padding: 0 10px;
  overflow: auto;
  @media (max-width: 800px) {
    padding: 0;
    margin-left: -10px;
  }
`;

const DeviceSection = styled.section`
  flex: 3 1 0px;
  display: flex;
  flex-direction: column;
`;

const MobileQuestionManagement = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobileQuestionButton = styled.div`
  display: flex;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  color: white;
  color: var(--se-secondary-contrast, white);
  padding-left: 5px;
`;

const MobileQuestionButtonLabel = styled.span`
  font-size: 14px;
  margin-left: 5px;
`;

const ArrowWrapper = styled.div`
  width: 32px;
  height: 32px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingMask = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: grey;
  z-index: 20;
  opacity: 0.2;
`;

const AddModuleSection = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 10px;
  justify-content: flex-end;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const NavigationButtonSection = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-top: 2px solid #cccc;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;

class ModalPacdriveAdjust extends React.PureComponent {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      moduleSelected: props.headModule.id,
      options: props.pacdriveKits.kits[props.headModule.id] || {},
      pacdriveKits: props.pacdriveKits.kits,
      openMobileQuestionsCallback: null
    }

  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted(objectToAffect) {
    if (this._isMounted) {
      this.setState(objectToAffect);
    }
  }

  toggleMobileFilter = (status) => {
    this.updateStateIfMounted({ mobileFilterOpened: status });
  }

  renderMobileQuestionButton = () => {
    const label = I10n.get('screen.head_device_selector_screen.plc.filters');
    return <MobileQuestionButton onClick={() => {
      this.toggleMobileFilter(true);
    }}>
      <MsxIcons name="filter"></MsxIcons>
      <MobileQuestionButtonLabel>{label}</MobileQuestionButtonLabel>
      <ArrowWrapper>
        <MsxIcons name="right-arrow" size="nano"></MsxIcons>
      </ArrowWrapper>
    </MobileQuestionButton>;
  }

  onAnswerChanged = (nextRef) => {
    this.updateStateIfMounted({ moduleSelected: nextRef, options: this.state.pacdriveKits[nextRef] });
  }

  get nbOptionsSelected() {
    let nbOptionsSelected = 0;
    if (this.state.options) {
      for (let categoryKey of Object.keys(this.state.options)) {
        const category = this.state.options[categoryKey];
        for (let kitKey of Object.keys(category)) {
          const kit = category[kitKey];
          if (kit.toggle) {
            nbOptionsSelected++;
          }
        }
      }
    }
    return nbOptionsSelected;
  }

  get options() {
    return this.state.options;
  }

  renderPacdriveModule = () => {
    const selectedDeviceObj = { id: this.state.moduleSelected }
    return (
      <ModuleCategory
        title={I10n.get(`screen.pacdrive_adjust.modal.lmc_kits.${this.props.headModule.rangeOfProduct}`)}
        label={I10n.get(`screen.pacdrive_adjust.modal.lmc_kits.${this.props.headModule.rangeOfProduct}`)}
        description={I10n.get('screen.head_device_selector_screen.plc.suggest')}
        detailedDescription={I10n.get('screen.head_device_selector_screen.plc.suggest')}
        image={this.props.headModule.sidePicture}
        references={[selectedDeviceObj]}
        setSelectedDevice={(device) => {
          this.updateStateIfMounted({ moduleSelected: device.id });
        }}
        selectedDevice={selectedDeviceObj}
        key={I10n.get(`screen.pacdrive_adjust.modal.lmc_kits`)}
        withCount={false}
        onOpenStateChange={(isOpen, ref) => {
        }}
        // Do not use force forceOpen to open if still loading
        forceOpen={true}
      ></ModuleCategory>
    )
  }

  render = () => {
    return (<Container>
      <Header id="modal-pacdrive-ajust-header">
      <TitleWrapper>
        <Title>{I10n.get('module_setting.action.adjust')}</Title>
        <CloseIcon onClick={(e) => {
          e.preventDefault();
          this.props.closeModal();
        }}>
          <MsxIcons name="close"></MsxIcons>
        </CloseIcon>
        </TitleWrapper>
        <Subtitle>{I10n.get('modal.subtitle')}</Subtitle>
      </Header>
      <Body id="modal-pacDravice-adjust-body">
        <DescriptionText dangerouslySetInnerHTML={{ __html: I10n.get('screen.pacdrive_adjust.modal.subtitle') }}></DescriptionText>
        <ContentWrapper>
          <Content>
            <PacdriveOptions
              options={this.options}
              isLoading={this.props.pacdriveKits.isLoading}
              onAnswerChanged={this.onAnswerChanged}
              mobileFilterOpened={this.state.mobileFilterOpened}
              toggleMobileFilter={this.toggleMobileFilter}>

            </PacdriveOptions>
            <DeviceSection>
              <DeviceSectionHeadText>{I10n.get('screen.head_device_selector_screen.plc.suggest')}</DeviceSectionHeadText>
              <MobileQuestionManagement>
                {!this.props.pacdriveKits.isLoading && this.renderMobileQuestionButton()}
              </MobileQuestionManagement>
              <DeviceSectionContent>
                {this.props.pacdriveKits.isLoading &&
                  <LoadingMask>
                    <LoadingSpinner></LoadingSpinner>
                  </LoadingMask>}
                <Scrollbars ref={c => { this.scrollComponent = c }}>
                  {!this.props.pacdriveKits.isLoading && this.renderPacdriveModule()}
                </Scrollbars>
              </DeviceSectionContent>
            </DeviceSection>
          </Content>          
        </ContentWrapper>
      </Body>
      <NavigationButtonSection>
            <AddModuleSection>
              <Button importance="emphasized" primary
                onClick={event => {
                  this.props.onSubmit(this.state.moduleSelected);
                }}
              >
                {(this.nbOptionsSelected > 0) ? I10n.get('screen.pacdrive_adjust.modal.select_kit') : I10n.get('screen.pacdrive_adjust.modal.select_basic')}
              </Button>
            </AddModuleSection>
          </NavigationButtonSection>
    </Container>);
  }

}


const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalPacdriveAdjust);
